export const ROUTES = {
	AUTH: {
		LOGIN: "/auth/login",
		RESET_PASSWORD: "/auth/reset-password",
		VERIFY_EMAIL: "/auth/verify-email",
	},
	DASHBOARD: "/",
	PROMOTERS: {
		LIST: "/promoters",
		DETAIL: (id: string) => `/promoters/${id}` as const,
	},
	PROJECTS: {
		LIST: "/projects",
		DETAIL: (id: string) => `/projects/${id}` as const,
	},
	INVESTMENTS: {
		INVESTORS: "/investments/investors",
		MAIN: "/investments/main",
		CALCULATOR: "/investments/calculator",
		CONTRACTS: "/investments/contracts",
		DETAIL: (uuid: string) => `/investments/${uuid}` as const,
	},
	ORGANIZATION: {
		GENERAL: "/organization",
		USERS: "/organization/users",
		TEMPLATES: "/organization/templates",
		TEMPLATE_DETAIL: (id: string) => `/organization/templates/${id}` as const,
		TEMPLATE_EDIT: (id: string) =>
			`/organization/templates/${id}/edit` as const,
	},
	ADMIN: {
		ROOT: "/admin",
		DASHBOARD: "/admin/dashboard",
		ORGANIZATIONS: "/admin/organizations",
		ORGANIZATION_DETAIL: (uuid: string) =>
			`/admin/organizations/${uuid}` as const,
		USERS: "/admin/users",
		USER_DETAIL: (uuid: string) => `/admin/users/${uuid}` as const,
	},
	HUB: {
		ROOT: "/hub",
		DASHBOARD: "/hub/dashboard",
		PROFILE: "/hub/profile",
		INVESTMENT_DETAIL: (uuid: string) => `/hub/investments/${uuid}` as const,
		INVESTMENT_ACTION: (uuid: string) =>
			`/hub/investments/${uuid}/action` as const,
		DOCUMENT_VIEW: (uuid: string, docUuid: string) =>
			`/hub/investments/${uuid}/documents/${docUuid}` as const,
		SIGNING_CALLBACK: "/hub/signing-callback",
	},
	SETTINGS: "/settings",
	HELP: "/help",
	INVITATIONS: {
		ACCEPT_MEMBER: "/organization-member/accept",
	},
} as const;
